import { FieldPath, FieldValues, UseFormSetError } from "react-hook-form";

const hasOwnProperty = <T extends object>(
  data: T,
  key: any
): key is keyof T => {
  return Object.prototype.hasOwnProperty.call(data, key);
};

export function showServerErrors<T extends FieldValues>(
  setError: UseFormSetError<T>,
  errors: Record<FieldPath<T>, string[]>
) {
  for (const fieldName in errors) {
    if (hasOwnProperty(errors, fieldName)) {
      setError(fieldName, { message: errors[fieldName][0] });
    }
  }
}

export function getFirstServerError(
  errors?: Record<string, string[]>
): string | undefined {
  if (!errors) return undefined;
  const firstKey = Object.keys(errors)[0];
  return firstKey ? errors[firstKey]?.[0] : undefined;
}
